export const avatarColors = ['blue', 'green', 'violet', 'orange', 'yellow'] as const;

export type AvatarColor = (typeof avatarColors)[number];

/**
 * The tint a person's avatar gets, keyed off their display name so the same person keeps the same
 * colour on every surface that draws them — profile header, lead cards, conversation transcript.
 * Any new avatar-ish node must call this rather than hashing the name itself, or the surfaces drift.
 *
 * The modulo is 4 rather than avatarColors.length, which leaves 'yellow' unreachable. That is the
 * original Avatar behaviour, kept deliberately: widening it to 5 reshuffles the colour of every
 * existing avatar in the app, which is a product call rather than a refactor.
 */
export function getAvatarColor(userName: string | null | undefined): AvatarColor {
  // charCodeAt on an empty string is NaN, which would index to undefined — fall back instead.
  return avatarColors[userName ? userName.charCodeAt(0) % 4 : 0];
}
